import React, {useEffect, useState} from "react";
import {
  apiAdminAccountFeaturesAdd,
  apiAdminAccountFeaturesList,
  apiAdminAccountFeaturesUpdate,
  apiAdminMerchantFeaturesList
} from "../../../../../../api/admin/features";
import Ripple from "../../../../../dumb/Ripple";
import openPopupEditMethods from "../Configs/components/Methods/utils/openPopupEditMethods";
import {BtnAddNew} from "../../../../../dumb/AdminHelpers/Buttons";
import {openPopupWindow} from "../../../../../../emitters/popup";
import Popup from "../../../../../dumb/Popup/C";
import {AdminCheckbox} from "../../../../../dumb/FormInputs";
import {FormFooter} from "../../../../../dumb/FormHandlers";
import Loading from "../../../../../dumb/Loading";
const {FormWrapper} = require('../../../../../dumb/FormHandlers');
const {AdminSwitch} = require('../../../../../dumb/FormInputs');

const openPopupFeatureAdd = ({userId, additionalFeaturesIds, additionalFeaturesData, update}) => openPopupWindow((setPopupState, popup) => {
  const {close} = popup;

  return () => {
    return (
      <Popup
        caption={(
          <div className="layoutRow fhaS fvaC w">
            <div>Add Feature</div>
          </div>
        )}
      >
        <FormWrapper
          onSubmit={(data) => {
            const featuresToEnable = Object.keys(data);
            const params = {account_id: userId, settings: {}};
            return Promise.all(featuresToEnable.map((feature_id) => {
              return apiAdminAccountFeaturesAdd({...params, feature_id})
            }))
          }}
          onResult={() => {
            update();
            close();
          }}
        >{(formCtx) => (
          <div className="pt12">
            {additionalFeaturesIds.map((id) => {
              return (
                <div
                  key={id}
                  className="pv8"
                >
                  <AdminCheckbox
                    name={id}
                    label={(
                      <div>
                        <div><b>{id}</b></div>
                        <div>{additionalFeaturesData[id]['description']}</div>
                      </div>
                    )}
                    formCtx={formCtx}
                  />
                </div>
              )
            })}
            <div>
              <FormFooter
                submitBtnData={{
                  text: 'Add Feature',
                  testId: 'submitNewFeatures',
                  formCtx
                }}
                additionalBtnsList={[
                  {text: 'Cancel', onClick: close},
                ]}
              />
            </div>
          </div>
        )}</FormWrapper>
      </Popup>
    );
  };
});

const FeatureItem = ({id, data, originalData, update}) => {
  const [loading, setLoading] = useState(false);
  const settings = data['settings'] || {};

  return (
    <div className="rlv">
      <div
        className={
          `w h abs st sl o0 bgF z-1 (o50|z10).loading`
          + (loading ? ' loading' : '')
        }
      />
      <div
        className={
          `abs st50% sl50% x-50%Y-50% o0 z-1 (o100|z15).loading (c0)>.CircularProgress`
          + (loading ? ' loading' : '')
        }
      >
        <Loading />
      </div>
      <div
        className="h45 ph15 layoutRow jcSB aiC f16 fw3 tc ttU c3E4044 bgFAFAFA b1 bs bcDCDCDC"
      >
        <h3 className="f16">
          {id}
        </h3>
        <div className="layoutRow aiC">
          {!data['enabledGlobally'] ? <div className="mr16 f12 fw3 cF00000">[disabled in global settings]</div> : ''}
          <div className={`o100 (o35).disabled` + (!data['enabledGlobally'] ? ' disabled' : '')}>
            <AdminSwitch
              value={data.enabled}
              onChange={() => {
                setLoading(true);
                apiAdminAccountFeaturesUpdate( {
                  ...originalData,
                  enabled: !data.enabled
                })
                  .then(update)
                  .finally(() => setLoading(false))
              }}
              disabled={loading}
              disableLabel
            />
          </div>
        </div>
      </div>
      <div className="ph15 c3E4044 bgFFFF b1 bt0 bs bcDCDCDC">
        <div className="pv8">
          <b>Description: </b><span>{data['desc']}</span>
        </div>
        {!!Object.keys(settings).length && (
          <div className="pv8">
            <b>Settings: </b><span>{JSON.stringify(data['settings'])}</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default (props) => {
  const userId = props.userId;

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    const getList = (obj = {}) => (obj.list || []);

    const featuresListGlobal = await apiAdminMerchantFeaturesList().then(getList);
    const featuresListMerchant = await apiAdminAccountFeaturesList({id: userId}).then(getList);

    const merchantsFeaturesIds = [];
    const merchantsFeaturesData = {};
    const merchantsOriginalData = {};

    const additionalFeaturesIds = [];
    const additionalFeaturesData = {};

    featuresListMerchant.forEach((el) => {
      merchantsFeaturesIds.push(el.feature_id);
      merchantsOriginalData[el.feature_id] = el;
      merchantsFeaturesData[el.feature_id] = {
        settings: el.settings,
        enabled: el.enabled
      }
    });

    featuresListGlobal.forEach((el) => {
      const featureData = {
        desc: el.description,
        enabledGlobally: el.enabled
      };

      if (merchantsFeaturesIds.includes(el.id)) {
        merchantsFeaturesData[el.id] = {
          ...merchantsFeaturesData[el.id],
          ...featureData
        }
      } else {
        additionalFeaturesIds.push(el.id);
        additionalFeaturesData[el.id] = el;
      }
    });

    setData({
      merchantsFeaturesIds,
      merchantsOriginalData,
      merchantsFeaturesData,
      additionalFeaturesIds,
      additionalFeaturesData
    });
  }

  useEffect(async () => {
    fetchData().finally(() => setLoading(false));
  }, []);

  if (loading) return <span />;

  const {
    merchantsFeaturesIds = [],
    additionalFeaturesIds = [],
    merchantsOriginalData = {},
    merchantsFeaturesData = {},
    additionalFeaturesData = {}
  } = data;

  return (
    <div className="pt30">
      <div className="layoutRow jcSB aiC mb30">
        <h2 className="m0 p0 f18 lh22 fw7">Merchant Features</h2>
        <BtnAddNew
          text={`Add Feature (${additionalFeaturesIds.length})`}
          onClick={() => openPopupFeatureAdd({userId, additionalFeaturesIds, additionalFeaturesData, update: fetchData})}
        />
      </div>
      <div>
        {merchantsFeaturesIds.map((id) => {
          return (
            <div key={id} className="mt26">
              <FeatureItem
                id={id}
                userId={userId}
                data={merchantsFeaturesData[id]}
                originalData={merchantsOriginalData[id]}
                update={fetchData}
              />
            </div>
          )
        })}
      </div>
    </div>
  );
}
